import { render, staticRenderFns } from "./detail_config_dataset_field.vue?vue&type=template&id=cccc81a8"
import script from "./detail_config_dataset_field.vue?vue&type=script&lang=js"
export * from "./detail_config_dataset_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cccc81a8')) {
      api.createRecord('cccc81a8', component.options)
    } else {
      api.reload('cccc81a8', component.options)
    }
    module.hot.accept("./detail_config_dataset_field.vue?vue&type=template&id=cccc81a8", function () {
      api.rerender('cccc81a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/customform/detail_config_dataset_field.vue"
export default component.exports